/* eslint-disable max-lines */
import { ExperienceTemplate } from 'experience-template-renderer-react';

const RFRR_PAGE_IDENTIFIER = 'HOT.HIS.SU.VR.';

export const singleOfferSmallTemplate: ExperienceTemplate = {
  id: 'single-offer-small',
  version: '1',
  components: [
    {
      metadata: {
        id: 'LayoutFlex',
      },
      type: 'UitkComponent',
      config: {
        type: 'UitkLayoutFlex',
        direction: 'column',
      },
      children: [
        {
          type: 'UitkComponent',
          metadata: { id: 'UitkLayoutFlexItemMainArea' },
          config: { type: 'UitkLayoutFlexItem', grow: 1 },
          children: [
            {
              metadata: {
                id: 'simpleContainer1',
              },
              type: 'LayoutGrid',
              config: {
                columns: 1,
              },
              children: [
                {
                  metadata: { id: 'top-row' },
                  type: 'LayoutGridItem',
                  config: {
                    colSpan: 3,
                  },
                  children: [
                    {
                      metadata: { id: 'back-to-search-link' },
                      type: 'PropertySummaryBackLinkWrapper',
                    },
                  ],
                },
                {
                  metadata: {
                    id: 'single-unit-vr',
                  },
                  type: 'LayoutGridItem',
                  config: {
                    colSpan: 3,
                  },
                  children: [
                    {
                      metadata: {
                        id: 'property-quick-reserve',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyQuickReserve`,
                        linkName: 'Property Quick Reserve',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-quick-reserve',
                          },
                          type: 'SharedUiStickyBookBarWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-top',
                      },
                      type: 'LayoutGridItem',
                      config: {
                        colSpan: 3,
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-gallery-tracker',
                          },
                          type: 'IntersectionTrackerWrapper',
                          config: {
                            rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyGallery`,
                            linkName: 'Property Gallery',
                          },
                          children: [
                            {
                              metadata: {
                                id: 'property-gallery',
                              },
                              type: 'PropertyGallery',
                            },
                          ],
                        },
                        {
                          metadata: {
                            id: 'property-navigation-tracker',
                          },
                          type: 'IntersectionTrackerWrapper',
                          config: {
                            rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyNavigation`,
                            linkName: 'Property Navigation',
                          },
                          children: [
                            {
                              metadata: {
                                id: 'property-navigation',
                              },
                              type: 'PropertyNavigation',
                              config: {
                                showReserveBtn: true,
                                showNightlyPrice: true,
                                showReserveBtnOnLoad: false,
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-summary-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertySummary`,
                        linkName: 'Property Summary',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-summary',
                          },
                          type: 'SingleOfferSummaryWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-level-message',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyLevelMessage`,
                        linkName: 'Property Level Message',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'message-card',
                          },
                          type: 'SharedUiPropertyLevelOffersMessageWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-price-box',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyPricebox`,
                        linkName: 'Property Price box',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'SingleOfferPricebox',
                          },
                          type: 'SingleOfferPriceWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-space-details',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertySpaceDetails`,
                        linkName: 'Property Space Details',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'space-details',
                          },
                          type: 'SpaceDetailsWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-about',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyAbout`,
                        linkName: 'Property About',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'about-property',
                          },
                          type: 'AboutThisPropertyWrapper',
                          config: {
                            columns: 1,
                          },
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-about-this-property-direct-feedback',
                      },
                      type: 'PropertyAboutThisPropertyDirectFeedbackWrapper',
                    },
                    {
                      metadata: {
                        id: 'property-amenities-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyAmenities`,
                        linkName: 'Property Amenities',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-amenities',
                          },
                          type: 'SharedUiAmenityDescriptionWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-similar-ads-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyMesoCarousel`,
                        linkName: 'Similar property ads',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-similar-ads',
                          },
                          type: 'SimilarHotelsMesoWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-similar-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertySimilar`,
                        linkName: 'Property Similar',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-similar',
                          },
                          type: 'SharedUiSimilarPropertiesWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-policies-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyPolicies`,
                        linkName: 'Property policies',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-policies',
                          },
                          type: 'SharedUiPoliciesWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-important-info-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyImportantInfo`,
                        linkName: 'Property Important Info',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-imp-info',
                          },
                          type: 'SharedUiImportantInfoWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-whats-around-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyWhatsAround`,
                        linkName: 'Property whats around',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'whats-around',
                          },
                          type: 'SharedUiWhatsAroundWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'activities-recommendations-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}ActivitiesRecommendations`,
                        linkName: 'activities recommendations',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'activities-recommendations',
                          },
                          type: 'ActivityRecommendationsWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'frequently-asked-questions-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyFaq`,
                        linkName: 'frequently asked questions',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'frequently-asked-questions',
                          },
                          type: 'SharedUiPropertyFaqWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-reviews-tracker',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyReviews`,
                        linkName: 'Property Reviews',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'property-reviews',
                          },
                          type: 'SharedUiPropertyReviewsWrapper',
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'property-host-profile',
                      },
                      type: 'IntersectionTrackerWrapper',
                      config: {
                        rfrrId: `${RFRR_PAGE_IDENTIFIER}PropertyHostProfile`,
                        linkName: 'Property Host Profile',
                      },
                      children: [
                        {
                          metadata: {
                            id: 'host-profile',
                          },
                          type: 'SharedUiPropertyHostProfileWrapper',
                          config: {
                            columns: 1,
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          metadata: {
            id: 'LayoutFlexItemSiderail',
          },
          type: 'UitkComponent',
          config: {
            type: 'UitkLayoutFlexItem',
          },
          children: [
            {
              metadata: {
                id: 'sideRailRegion',
              },
              type: 'SideRailRegion',
              children: [
                {
                  metadata: {
                    id: 'mesoSideRail',
                  },
                  type: 'MesoSideRail',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
